var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-carousel',{attrs:{"type":_vm.type,"height":_vm.height,"autoplay":_vm.autoplay,"interval":_vm.interval,"direction":_vm.direction}},_vm._l((_vm.data),function(item){return _c('el-carousel-item',{key:item.name},[_c('img',{staticStyle:{"border-radius":"10px"},attrs:{"src":item.url,"height":"200px","alt":""}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }